import { ComponentPropsWithoutRef } from 'react'

import { resolveParentCategories } from '@/lib/contentful/utils'

import { Breadcrumbs } from '@/components/Breadcrumbs'
import { Warning } from '@/components/Warning'

import { useEntry } from '../BlogPost.hooks'

export function BlogPostBreadcrumbs(
	props: Omit<ComponentPropsWithoutRef<typeof Breadcrumbs>, 'breadcrumbs' | 'currentPage'>
) {
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={props.className}>{entry.error}</Warning>
	}

	const category = entry.data.categoriesCollection?.items[0]

	if (!category) return null

	const parentCategories = [category, ...resolveParentCategories(category)].reverse()

	return (
		<Breadcrumbs
			{...props}
			breadcrumbs={[
				{
					text: 'Blog Home',
					link: { href: '/blog/' },
					schemaUrl: 'https://www.bigcommerce.com/blog/'
				},
				...parentCategories
					.slice()
					.reverse()
					.map((parent) => ({
						text: parent.name,
						link: { href: `/blog/category/${parent.slug}/` },
						schemaUrl: `https://www.bigcommerce.com/blog/category/${parent.slug}/`
					}))
			]}
			currentPage={entry.data.title}
		/>
	)
}
